//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AddRoute from '@/components/System/gatewayroutes/addroute';
import { getSystemInnerList } from '@/api/message';
import NoData from '@/components/NoData/NoData';
import { valsubstr32addbr } from '@/utils';
export default {
  components: {
    AddRoute: AddRoute,
    NoData: NoData
  },
  data: function data() {
    return {
      multipleSelection: null,
      delChecked: false,
      // 删除权限
      tableData: [],
      btnType: 'add,search',
      showPowerMaintain: false,
      // 角色与权限关联
      showPowerPower: false,
      // 查看权限
      ifAddEdit: false,
      // true 编辑  false 新增
      showRoleEdit: false,
      // 显示角色编辑弹出框
      showRoleUserEdit: false,
      // 指定用户
      selectpermissionId: 0,
      editPermission: null,
      isfiltrate: false,
      filtratedata: {
        pageNum: 1,
        pageSize: 10
      },
      formRole: {
        sysName: [],
        roleNum: null,
        roleName: [],
        type: null,
        desc: null,
        status: null
      },
      specificUserForm: {
        roleName: [],
        roleNum: null,
        userName: null,
        type: [],
        roleDep: [],
        tel: null
      },
      currentPage: 1,
      totalrecord: 0,
      ifShowDelDialog: false,
      lastversion: 0,
      loading: false,
      tableheight: 580,
      pageshow: true
    };
  },
  created: function created() {
    this.getrouteslist();
    this.gesystemlist();
    this.getlastversion();
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 300;

      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 300;
      };
    });
  },
  methods: {
    getrouteslist: function getrouteslist() {
      var _this = this;
      this.loading = true;
      this.$API.getRequest({
        url: '/platform/gateway-routes/list',
        data: this.filtratedata
      }).then(function (res) {
        _this.loading = false;
        if (res.code === '0000000000') {
          _this.tableData = res.result.records;
          _this.totalrecord = res.result.total;
        }
      });
    },
    gesystemlist: function gesystemlist() {
      var _this2 = this;
      getSystemInnerList().then(function (res) {
        var code = res.code;
        if (code === '0000000000') {
          _this2.$nextTick(function () {
            _this2.systemlist = res.result.records;
          });
        }
      });
    },
    getlastversion: function getlastversion() {
      var _this3 = this;
      this.$API.getRequest({
        url: '/platform/version/lastVersion'
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this3.lastversion = res.result;
        }
      });
    },
    // 确认是否提升版本号
    confirmaddversion: function confirmaddversion(bool) {
      if (bool) {
        this.addversion();
      }
    },
    // 提升版本
    addversion: function addversion() {
      var _this4 = this;
      this.$API.postRequest({
        url: '/platform/version/'
      }).then(function () {
        // if(res.code === "200"){
        _this4.getlastversion();
        // }
      });
    },
    handleSelectionChangeport: function handleSelectionChangeport(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.filtratedata.pageNum = val;
      this.getrouteslist();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.filtratedata.pageSize = val;
      // this.filtratedata.pageNum = 1;
      this.getrouteslist();
    },
    addTable: function addTable() {
      this.ifAddEdit = false;
      this.powerAddClose(true);
    },
    editRoleDialog: function editRoleDialog(item, bool) {
      this.ifAddEdit = bool;
      this.$refs["routes-".concat(item.row.id)].doClose();
      this.editPermission = JSON.parse(JSON.stringify(item.row));
      this.powerAddClose(true);
    },
    editRoleUserDialog: function editRoleUserDialog() {
      this.showRoleUserEdit = true;
    },
    powerAddClose: function powerAddClose(bool) {
      this.showRoleEdit = bool;
    },
    RoutesSubmit: function RoutesSubmit(obj) {
      if (obj.bool) {
        // 点击提交
        this.routesaddoramend(obj);
      } else {
        this.powerAddClose(false);
      }
    },
    // 新增或者编辑路由
    routesaddoramend: function routesaddoramend(obj) {
      if (this.ifAddEdit) {
        this.amendroutes(obj);
      } else {
        this.addroutes(obj);
      }
    },
    // 新增路由
    addroutes: function addroutes(obj) {
      var _this5 = this;
      this.$API.postRequest({
        url: '/platform/gateway-routes/route/',
        data: obj.formData
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this5.$message({
            message: '添加路由成功',
            type: 'success'
          });
          _this5.powerAddClose(false);
          _this5.pageshow = false;
          _this5.filtratedata.pageNum = _this5.totalrecord % _this5.filtratedata.pageSize === 0 ? Math.ceil(_this5.totalrecord / _this5.filtratedata.pageSize) + 1 : Math.ceil(_this5.totalrecord / _this5.filtratedata.pageSize);
          _this5.getrouteslist();
          _this5.$nextTick(function () {
            _this5.pageshow = true;
          });
          // this.getrouteslist();
        }
      });
    },
    // 修改路由
    amendroutes: function amendroutes(obj) {
      var _this6 = this;
      obj.formData.id = this.editPermission.id;
      this.$API.putRequest({
        url: '/platform/gateway-routes/route/',
        data: obj.formData
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this6.$message({
            message: '修改路由成功',
            type: 'success'
          });
          _this6.powerAddClose(false);
          _this6.getrouteslist();
        }
      });
    },
    // 单个是否删除路由操作
    confirmdel: function confirmdel(obj, bool) {
      var _this7 = this;
      if (bool) {
        var page = Math.ceil(this.totalrecord / this.filtratedata.pageSize); // 最大页数
        if (this.filtratedata.pageNum === page) {
          if (this.totalrecord % this.filtratedata.pageSize === 1) {
            this.filtratedata.pageNum > 1 ? this.filtratedata.pageNum-- : this.filtratedata.pageNum = 1;
          }
        }
        this.$refs["routes-".concat(obj.row.id)].doClose();
        this.$API.delRequest({
          url: "/platform/gateway-routes/".concat(obj.row.id)
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this7.$message({
              message: '删除路由成功',
              type: 'success'
            });
            _this7.getrouteslist();
          }
        });
      }
    },
    // tooltips过长换行(length 32换行)
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    }
  }
};